mainApp.component('expandableSection', {
	templateUrl: '/public/components/expandable-section.component.html',
	bindings: {
		label: '@',
		summary: '@',
		oneLiner: '<',
		initiallyCollapsed: '<',
		onExpandEvent: '&',
		onCollapseEvent: '&',
		fireEventOnInit: '<'
	},
	transclude: true,
	controller: expandableSectionController
});

function expandableSectionController($element) {
    var ctrl = this;
    ctrl.buttonClass = '';

    ctrl.$postLink = function() {
        ctrl.collapsed = false;

        var $header = $($element.children()[0]);

        if (ctrl.initiallyCollapsed) {
            ctrl.collapsed = true;
            toggleButtonClass();
        }

        ctrl.toggleState($header, ctrl.fireEventOnInit);
    }

    ctrl.showEditMode = function ($event) {
        $event.stopPropagation();

        ctrl.collapsed = !ctrl.collapsed;

        ctrl.toggleState($($event.currentTarget), true);
    }

    ctrl.toggleState = function($targetEl, fireEvent) {
        var $expandedEl = $targetEl.siblings('.expandable');

        $expandedEl.clearQueue();
        if (ctrl.collapsed) {
            $expandedEl.slideUp(300);
            !fireEvent || ctrl.onCollapseEvent($targetEl.parent());
        } else {
            $expandedEl.slideDown(300);
            !fireEvent || ctrl.onExpandEvent($targetEl.parent());
        }
        toggleButtonClass();
    }

    function toggleButtonClass() {
        ctrl.buttonClass = ctrl.buttonClass == '' ? 'open' : '';
    }
}